import { TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { ProtocolCallRequestEventFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

export function ProtocolCallRequestEventForm() {
	/** Context */
	const methods = useFormContext<ProtocolCallRequestEventFormSchema>();
	const { t } = useTranslation();

	/** Render */
	return (
		<TextInput
			control={methods.control}
			name="note"
			isRequired={false}
			label={t("protocols.callback_note")}
			placeholder={t("protocols.callback_note_placeholder")}
		/>
	);
}
